import routingConfig from "@/config/routing.json"
import {createRouter, createWebHistory} from 'vue-router'
import {useAdmin, useLayout, container, useUserStore} from "@/plugins/obscore"

export default class AbstractRouterManager {
    constructor() {
        this.router = createRouter({
            history: createWebHistory(),
            routes: []
        })
        this.router.beforeEach((to) => {
            if (to.meta.admin) {
                container.admin = useAdmin(to.meta.admin)
                container.admin.configure(to);
            } else {
                container.admin = {
                    title: "Test",
                    icon: "mdi-folder"
                }
            }
            const auth = useUserStore();
            auth.lastVisitedRoute = to.name !== 'login' ? to : auth.lastVisitedRoute;
            if (!auth.token && (!routingConfig[to.name] || !routingConfig[to.name].public)) {
                return this.getRoute("login");
            }
        })
    }

    loadRoutes() {
        for (let routeName in routingConfig) {
            this.getRoute(routeName)
        }
    }

    getRoute(name) {
        if (!routingConfig[name]) {
            console.error(`Undefined Route with name '${name}'`,)
        }
        if (!this.router.hasRoute(name))
            this.router.addRoute({
                name: `${name}`,
                path: `${routingConfig[name].path}`,
                component: () => useLayout(routingConfig[name].layout),
                props: routingConfig[name].props
            })

        return routingConfig[name]
    }

    getRouter() {
        return this.router
    }

}